// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1_AC9","resendInfoText":"OnGoingPaymentBox_resendInfoText__2ZiJf"};